import FilterActionsEnums from './FilterActionsEnums'

export const setFilterClientAction = (selectedClient) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_CLIENT, selectedClient});
    };
};

export const setFilterBUAction = (selectedBu) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_BU, selectedBu});
    };
};

export const setFilterLocationAction = (location) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_LOCATION, location});
    };
};

export const setFilterShopAction = (selectedShop) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_SHOP, selectedShop});
    };
};

export const setStartDateAction = (startDate) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_START_DATE, startDate});
    };
};

export const setEndDateAction = (endDate) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_END_DATE, endDate});
    };
};

export const setStartSettDateAction = (startSettDate) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_START_SETT_DATE, startSettDate});
    };
};

export const setEndSettDateAction = (endSettDate) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_END_SETT_DATE, endSettDate});
    };
};

export const setFilterPaymentTypeAction = (paymentType) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_PAYMENT_TYPE, paymentType});
    };
};

export const setFilterActivityAction = (activity) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_ACTIVITY, activity});
    };
};

export const setReportingFilterIsOpenAction = (isOpenReportingFilter) => {
    return dispatch => {
        dispatch({type: FilterActionsEnums.SET_REPORTING_FILTER_OPEN, isOpenReportingFilter});
    };
};


// WEBPACK FOOTER //
// ./src/store/filters/FilterActions.js